import styled from 'styled-components';
import { palette, Card, CardGrid } from '@m12s/component-library';
import { zLayer } from 'lib/utils/styled';
import { H5 } from 'components/Text';

// The body (SwipeUpModal detailsStyles) owns padding (24px) + gap (24px) to
// match the demo, so the search/grid children carry none of their own.
const InputWrapper = styled.div`
  width: 100%;
  flex-shrink: 0;
  display: ${({ hidden }) => {
    return hidden ? 'none' : 'block';
  }};
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${palette.Grey100};
  position: relative;
  z-index: ${zLayer.overlay};
`;

const GridWrapper = styled.div`
  width: 100%;
`;

// The base CardGrid collapses to a single column in portrait; the demo keeps a
// 3-column grid of operator cards with a 16px gap regardless of orientation.
const OperatorGrid = styled(CardGrid)`
  grid-column-gap: 16px;
  grid-row-gap: 16px;

  @media (orientation: portrait) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

// Matches the demo OperatorCard exactly (fixed px, not rem, so it doesn't scale
// past the demo on hi-dpi tablets): 120px tall, white, 1px Grey400 (#CBD5E0)
// border, 8px radius, three-stop drop-shadow (not box-shadow), name Noto Sans
// 20px/24px medium (500) Grey700, centered, 0.1px tracking. `type="pill"` still
// centers the label; we override its 40px radius and default box-shadow.
const CardGridItem = styled(Card)`
  border: 1px solid ${palette.Grey400};
  border-radius: 8px;
  min-height: 120px;
  box-shadow: none;
  filter: drop-shadow(0px -1px 2px rgba(26, 32, 44, 0.05))
    drop-shadow(0px 1px 1.5px rgba(26, 32, 44, 0.16))
    drop-shadow(0px 1px 0.5px rgba(26, 32, 44, 0.08));
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: ${palette.Grey700};
  text-align: center;
`;

const HeaderText = styled(H5)`
  width: 100%;
  text-align: left;
  padding-left: 1.5rem;
  font-weight: 500;
  margin-left: -8rem;
`;

export {
  Root,
  GridWrapper,
  InputWrapper,
  CardGridItem,
  OperatorGrid,
  HeaderText,
};
